function getCurrentLanguage() {
  return document.documentElement.lang;
}

function getShippingMetaObject() {
  let currentLanguage = getCurrentLanguage();
  let myHeaders = new Headers();
  myHeaders.append(
    "X-Shopify-Storefront-Access-Token",
    "2b1aa56393bc7d55879c3f743a3d6fe4"
  );
  myHeaders.append("Content-Type", "application/json");

  let graphql = JSON.stringify({
    query:
      `query{\r\n metaobjects(type: "shipping_rates", first: 100) {\r\n    nodes {\r\n      delivery: field(key: "delivery_method") { value }\r\n      country: field(key: "country") { value }\r\n      cost: field(key: "cost") { value },\r\n      speed: field(key: "delivery_speed") { value }\r\n      order: field(key: "order") { value }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n`,
    variables: {},
  });
  
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch (
    "https://pureromancedtc.myshopify.com/api/2023-01/graphql.json",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
}

async function createShippingTable(parentElement, countryToFilter) {
  const dataSet = await getShippingMetaObject();

  // Parse the data set into a JavaScript object
  const data = JSON.parse(dataSet);

  // Access the nodes array and filter by country
  const filteredNodes = data.data.metaobjects.nodes.filter(
    (node) => node.country.value === countryToFilter
  );

  // Create the HTML table
  const table = document.createElement("table");
  table.id = "shippingTable";

  // Create the table headers
  const headers = ["Service", "Cost", "Delivery"];
  const headerRow = document.createElement("tr");
  headerRow.innerHTML = headers.map((header) => `<th>${header}</th>`).join("");
  table.appendChild(headerRow);

  // Create the table rows
  const rows = filteredNodes
    .map((node) => {
      const costArray = JSON.parse(node.cost.value);
      const costHTML = costArray.map((cost) => `<div>${cost}</div>`).join("");
      return `
      <tr>
        <td>${node.delivery.value}</td>
        <td>${costHTML}</td>
        <td>${node.speed.value}</td>
      </tr>
    `;
    })
    .join("");
  table.innerHTML += rows;

  // Append the table to the parentElement
  document.querySelector(parentElement).appendChild(table);
}


function initSearchPredictive() {
  const searchForms = document.querySelectorAll('.search__predictive__form');

  function handleChangeInSearchInput(searchInput, searchClose) {
    searchClose.classList.toggle('search__predictive__close__inner--active', searchInput.value !== '');
  }

  function handleSearchCloseClick(e, searchInput, searchClose) {
    e.preventDefault();
    searchInput.value = "";
    handleChangeInSearchInput(searchInput, searchClose);
  }

  searchForms.forEach(form => {
    const searchInput = form.querySelector('.search__predictive__form > input[type="search"]');
    const searchClose = form.querySelector('.search__predictive__close__inner');

    searchInput.addEventListener('input', () => handleChangeInSearchInput(searchInput, searchClose));
    searchClose.addEventListener('click', (e) => handleSearchCloseClick(e, searchInput, searchClose));
  })
}

initSearchPredictive();

// keeps heart / favorite button state updated across the current page
document.addEventListener('DOMContentLoaded', () => {
  const heartButtons = document.querySelectorAll('button.heart-button');
  for (let button of heartButtons) {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      setTimeout(() => {
        _swat.initializeActionButtons('body');
      } ,1000)
    })
  }
});